import React from "react";
import { useStyletron } from "baseui";
import { HeadingXLarge, ParagraphLarge } from "baseui/typography";
import type { DocsInterfaceProps } from "../../../../src/chrome/DocsInterface";
import { DocsInterface } from "../../../../src/chrome/DocsInterface";
import { SplashCard, SplashCardGrid, SplashContentContainer, colors } from "../../../../src/components/SplashPage";

const WebAppTutorialsLandingPage = (props: DocsInterfaceProps) => {
  const [css, $theme] = useStyletron();

  return (
    <DocsInterface {...props} showLeftSideNav={true}>
      <SplashContentContainer $style={{ maxWidth: "980px" }}>
        <HeadingXLarge>Web app tutorials</HeadingXLarge>
        <ParagraphLarge
          $style={{
            paddingTop: $theme.sizing.scale800,
            paddingBottom: $theme.sizing.scale800,
            fontWeight: 300,
          }}
        >
          Learn to build fullstack web apps using the built-in authentication system and OpenAI plugin.
        </ParagraphLarge>
        <SplashCardGrid $maxColumns={2} className={css({ marginTop: $theme.sizing.scale1200 })}>
          <SplashCard
            title="Ai Screenwriter"
            color={colors.white}
            body="Learn how to build a chatbot that writes fake movie scenes using the OpenAI plugin and vector embeddings."
            href="/guides/tutorials/ai-screenwriter"
            copy="Start building →"
          />
          <SplashCard
            title="Subscribe to webhooks"
            color={colors.white}
            body="Learn how to subscribe to 3rd party webhooks (using Github as an example)."
            href="/guides/tutorials/webhook-subscription"
            copy="Start building →"
          />
        </SplashCardGrid>
      </SplashContentContainer>
    </DocsInterface>
  );
};

export default WebAppTutorialsLandingPage;
